import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress-item__start"
}
const _hoisted_2 = ["tile"]
const _hoisted_3 = { class: "progress-item__subtitle" }
const _hoisted_4 = {
  key: 2,
  class: "progress-item__caption"
}

import ProgressBar from "./ProgressBar.vue";
interface ProjectItemProps {
  color?: string | null;
  title?: string;
  percentage?: number | number[];
  max?: string;
  value?: string;
  isValueError?: boolean;
  isStartVisible?: boolean;
  dangerPercent?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressItem',
  props: {
    color: {},
    title: {},
    percentage: {},
    max: {},
    value: {},
    isValueError: { type: Boolean },
    isStartVisible: { type: Boolean },
    dangerPercent: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      'progress-item',
      { 'progress-item--start-visible': __props.isStartVisible },
    ])
  }, [
    (_ctx.$slots.start)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "start")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "progress-item__title",
      tile: __props.title
    }, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ])
    ], 8, _hoisted_2),
    (__props.percentage !== null && __props.percentage !== undefined)
      ? (_openBlock(), _createBlock(ProgressBar, {
          key: 1,
          class: "progress-item__progress",
          percentages: __props.percentage,
          "danger-percent": __props.dangerPercent,
          color: __props.color
        }, null, 8, ["percentages", "danger-percent", "color"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "subtitle")
    ]),
    (_ctx.$slots.caption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "caption")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})